import { SharedModule } from 'src/app/components/shared.module';
import { NgModule } from '@angular/core';
import { MedicalFeeSearchModule } from './medical-fee/medical-fee-search/medical-fee-search.module';
import { MedicalFeeControlSearchModule } from './medical-fee/medical-fee-control-search/medical-fee-control-search.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MedicalFeePaymentModule } from './medical-fee/medical-fee-payment/medical-fee-payment.module';
import { MedicalFeePrePaymentSearchModule } from './medical-fee/medical-fee-pre-payment-search/medical-fee-pre-payment-search.module';
import { MedicalFeePaymentManualWizardModule } from './medical-fee/medical-fee-payment-manual-wizard/medical-fee-payment-manual-wizard.module';
import { MedicalFeePaymentManualSearchModule } from './medical-fee/medical-fee-payment-manual-search/medical-fee-payment-manual-search.module';
import { MedicalFeePaymentSearchModule } from './medical-fee/medical-fee-payment-search/medical-fee-payment-search.module';
import { BillingInvoiceManualSearchModule } from './billing/billing-invoice-manual-search/billing-invoice-manual-search.module';
import { BillingInvoiceManualEditModule } from './billing/billing-invoice-manual-edit/billing-invoice-manual-edit.module';
import { BillingInvoiveViewComponent } from './billing/billing-invoive-view/billing-invoive-view.component';
import { BillingInvoiceManualCreditEditComponent } from './billing/billing-invoice-manual-credit-edit/billing-invoice-manual-credit-edit.component';
import { BillingInvoiceManualCreditEditModule } from './billing/billing-invoice-manual-credit-edit/billing-invoice-manual-credit-edit.module';
import { PreConclusionDiagnosticPanelModule } from './controls/pre-conclusion-diagnostic-panel/pre-conclusion-diagnostic-panel.module';
import { ExtraccionistaModule } from './extraccionista/extraccionista.module';
import { StructuredDiagnosisPanelModule } from './controls/structured-diagnosis-panel/structured-diagnosis-panel.module';
import { IntegratedAdmissionModule } from './integrated-admission/integrated-admission.module';
import { BudgetModule } from './budget/budget.module';
import { LaboratoryTubesModule } from './laboratory-tubes/laboratory-tubes.module';
import { MedicalAppointmentAuditingModule } from './medical-appointment-auditing/medical-appointment-auditing.module';

@NgModule({
    declarations: [
    ],
    imports: [
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MedicalFeeSearchModule,
        MedicalFeeControlSearchModule,
        MedicalFeePaymentModule,
        MedicalFeePaymentManualWizardModule,
        MedicalFeePrePaymentSearchModule,
        MedicalFeePaymentManualSearchModule,
        MedicalFeePaymentSearchModule,
        BillingInvoiceManualSearchModule,
        BillingInvoiceManualEditModule,
        BillingInvoiceManualCreditEditModule,
        PreConclusionDiagnosticPanelModule,
        StructuredDiagnosisPanelModule,
        ExtraccionistaModule,
        MedicalAppointmentAuditingModule,
        LaboratoryTubesModule,
        IntegratedAdmissionModule,
        BudgetModule
    ],
    exports: [
    ]
  })
  export class PagesModule { }
